module.exports = __webpack_public_path__ + "img/2014-11_bloomberg.45f28ecf.png";